// extracted by mini-css-extract-plugin
export default {"skippedFilesContainer":"SkippedFiles_skippedFilesContainer__sOGzn","skipped":"SkippedFiles_skipped__cHKF+","ids":"SkippedFiles_ids__Z8tgz","buttons":"SkippedFiles_buttons__I0to-"};